// Un seul écran Matchs (D-132 ; Idries : « ok pour tes recos » — « Matchs » désignait trois écrans) : tout le club, avec
// un filtre par équipe, comme le Planning. La paire « Matchs et résultats » / « Matchs du club » disparaît côté bureau ;
// côté membres, les deux tuiles de l'onglet Club (maquette m7) ouvrent ce même écran, l'une sur leur équipe.
//   #/matchs             tout le club : « Suivre » (D-110), à venir (3 semaines) et résultats, « Je viens voir »,
//                        encourager (D-066) ;
//   #/matchs/resultats   tout le club, les résultats ;
//   #/matchs/<équipe>    une de mes équipes (le bureau : toutes) : prochain match, résultats, bilan, classement, les
//                        compétitions FFBB et leur synchro pour le staff (D-018, D-090).
// Les anciennes adresses #/matchs-club[/resultats] y mènent (renamedRoute, src/domain/modules.ts) ; l'abonné garde son
// accueil (D-110).
import { activeSeason } from '../lib/api';
import { renderTeamPhoto } from './team-photo';
import { renderTeamMatches } from './team-matches';
import { renderClubBoard } from './supporters';
import { workTeams, type Ctx } from './context';
import { tv } from './vous';
import { $, html, mount } from './dom';

export async function renderMatchs(root: HTMLElement, ctx: Ctx, arg?: string): Promise<void> {
  const club = ctx.club;
  if (!club) { mount(root, html`<div class="empty"><p class="empty-title">Aucun club.</p></div>`); return; }
  // Les équipes de la saison active (pas celles d'une saison archivée), une fois chacune.
  const season = await activeSeason(club.id).catch(() => null);
  const teams = [...new Map(workTeams(ctx).map(t => [t.id, t])).values()].filter(t => !season || !t.season_id || t.season_id === season.id);
  const team = arg && arg !== 'resultats' ? teams.find(t => t.id === arg) ?? null : null;
  const strip = teams.length ? html`
    <nav class="team-strip" aria-label="Filtrer par équipe" data-guide="mx-teams">
      <a class="team-pill ${team ? '' : 'on'}" href="#/matchs" ${team ? '' : html`aria-current="page"`}>Tout le club</a>
      ${teams.map(t => html`<a class="team-pill ${team?.id === t.id ? 'on' : ''}" href="#/matchs/${t.id}" ${team?.id === t.id ? html`aria-current="page"` : ''}>${t.name}</a>`)}
    </nav>` : '';
  if (team) {
    mount(root, html`
      <section class="screen">
        <header class="screen-head tph-head"><div id="team-photo"></div><div><p class="eyebrow">${team.name}</p><h2>Matchs</h2></div></header>
        ${strip}
        <div id="sec" class="screen"></div>
      </section>`);
    const ph = $(root, '#team-photo');
    if (ph) void renderTeamPhoto(ph, team, ctx.staffOf.has(team.id)).catch(() => undefined);
    await renderTeamMatches($(root, '#sec')!, ctx, team, ctx.staffOf.has(team.id));
    return;
  }
  mount(root, html`
    <section class="screen">
      <header class="screen-head"><p class="eyebrow">${club.name}</p><h2>Matchs</h2>
        <p class="muted">${tv(ctx, 'Tout le club : dis aux équipes que tu viens les voir, laisse-leur un mot ; elles sont prévenues.',
          'Tout le club : dites aux équipes que vous venez les voir, laissez-leur un mot ; elles sont prévenues.')}</p></header>
      ${strip}
      <div id="sec" class="screen"></div>
    </section>`);
  const sec = $(root, '#sec')!;
  const show = (v: 'next' | 'past') => renderClubBoard(sec, ctx, v, show);
  await show(arg === 'resultats' ? 'past' : 'next');
}
